import { render, staticRenderFns } from "./roomDig.vue?vue&type=template&id=1ad6dc25&scoped=true"
import script from "./roomDig.vue?vue&type=script&lang=js"
export * from "./roomDig.vue?vue&type=script&lang=js"
import style0 from "./roomDig.vue?vue&type=style&index=0&id=1ad6dc25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad6dc25",
  null
  
)

export default component.exports